import { Gruser } from '@wix/da-gruser-shared/pkg/types/papi';
import { updateModule } from '@wix/da-gruser-shared/pkg/redux/actions/modules';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { PapiModuleTierContent } from '@wix/da-papi-types';
import { withOffset } from '@wix/da-shared-react/pkg/Stream';
import { setTotalPages } from '../../../../../../actions/pageInfo';
import {
  TIER_CONTENT_DEVIATIONS_PER_FETCH,
  TIER_CONTENT_DEVIATIONS_STREAM_GROUP_ID,
  TIER_CONTENT_POSTS_PER_FETCH,
  getTierContentDeviationsStreamId,
} from '../../../../../../streams/tierContent';
import { setSectionStreamId } from '../../../../../../actions/sections';
import { getDeviationsCommentsInitActions } from '../../../../../../store/initActions/common';

export default (
  gruser: Gruser,
  moduleId: number,
  moduleData: PapiModuleTierContent,
  requestParams: any
) => {
  const {
    tierDeviationid: tierDeviationId,
    deviations = [],
    posts = [],
    deviationsNextOffset,
    deviationsHasMore,
    postsNextOffset,
    postsHasMore,
    totalPageCount,
  } = moduleData as any; // Extended module data with both content types

  const normalizedDeviations = normalize(deviations, [deviationSchema]);
  const normalizedPosts = normalize(posts, [deviationSchema]);

  const deviationsStreamId = getTierContentDeviationsStreamId(
    tierDeviationId,
    'deviations'
  );
  const postsStreamId = getTierContentDeviationsStreamId(
    tierDeviationId,
    'posts'
  );

  return [
    // Initialize deviations stream
    withOffset.actions.initialize({
      streamId: deviationsStreamId,
      groupId: TIER_CONTENT_DEVIATIONS_STREAM_GROUP_ID,
      itemsPerFetch: TIER_CONTENT_DEVIATIONS_PER_FETCH,
      streamParams: {
        tierDeviationId,
        section: 'deviations',
      },
      items: normalizedDeviations.result,
      entities: normalizedDeviations.entities,
      nextOffset: deviationsNextOffset || null,
      hasMore: deviationsHasMore || false,
    }),
    // Initialize posts stream
    withOffset.actions.initialize({
      streamId: postsStreamId,
      groupId: TIER_CONTENT_DEVIATIONS_STREAM_GROUP_ID,
      itemsPerFetch: TIER_CONTENT_POSTS_PER_FETCH,
      streamParams: {
        tierDeviationId,
        section: 'posts',
      },
      items: normalizedPosts.result,
      entities: normalizedPosts.entities,
      nextOffset: postsNextOffset || null,
      hasMore: postsHasMore || false,
    }),
    setSectionStreamId(deviationsStreamId),
    setTotalPages(totalPageCount || 1),
    ...getDeviationsCommentsInitActions([...deviations, ...posts]),
    updateModule(gruser, {
      id: moduleId,
      moduleMeta: {
        isInitialized: true,
      },
    }),
  ] as any;
};
